<template>
  <div class="tasks-kanban-filter">
    <div class="tasks-kanban-filter__elements">
      <div class="tasks-kanban-filter__first-section">
        <div v-if="!isSortingAndGroupingHidden" class="tasks-kanban-filter__button-settings">
          <TasksKanbanFilterGrouppingDropdown
            :model-value="grouppingType"
            :isDisabled="props.isDisabled"
            :allowNoneGroupping="allowNoneGroupping"
            @update:model-value="updateGrouppingType"
            @checkOpenOptionsFilterGroupping="checkOpenOptionsFilterGroupping"
          />
        </div>
        <TaskKanbanCardViewSettingsDropdown
          :isSortingAndGroupingHidden="isSortingAndGroupingHidden"
          :disabled-checkboxes="disabledViewElementsCheckboxes"
          :hidden-checkboxes="hiddenViewElements"
          :hideStatus="hideStatus"
          :model-value="viewElements"
          @update:model-value="checkViewElement"
          @checkOpenOptionsViewSettings="checkOpenOptionsViewSettings"
        />
      </div>
      <div class="tasks-kanban-filter__second-section button-filter">
        <TirPmPopover
          ref="$popover"
          :isHideTriangle="false"
          :position="PopoverPositionEnum.Bottom"
          :is-disabled="isDisabledFilter"
          width="28.3125rem"
        >
          <template #default>
            <TirPmTooltipElement :is-disabled="!noAccessTooltip">
              <TirPmButton
                v-if="!isFilterHidden"
                class="tasks-kanban-filter__button-settings"
                :variant="TirPmButtonVariantEnum.LinkState"
                :size="TirPmButtonSizeEnum.Small"
                :is-disabled="isDisabledFilter"
              >
                Фильтры
                <template #leftSlot>
                  <FunnelIcon />
                </template>
                <template #rightSlot>
                  <div
                    v-if="isApplyFilter"
                    style="
                      position: absolute;
                      top: 0rem;
                      right: 0rem;
                      width: 0.5rem;
                      height: 0.5rem;
                      border-radius: 0.5rem;
                      background: #00f;
                    "
                  ></div>
                </template>
              </TirPmButton>
              <template #content>
                {{ noAccessTooltip }}
              </template>
            </TirPmTooltipElement>
            <div v-if="changeIndicatorState" class="change-indicator" />
          </template>
          <template #content>
            <OptionsFilter
              :searchField="searchField"
              :filterOptions="filterOptions"
              :selectedOptionsFilter="selectedOptionsFilter"
              :previousFilterValues="previousSelectedFilterValues"
              :isDisabledCancelFilter="isDisabledCancelFilter"
              :isApplyFilter="isApplyFilter"
              :isChangeGlobalStatus="isChangeGlobalStatus"
              :isChange="isChange"
              :showOnlyCurrentIsAdmin="showOnlyCurrentIsAdmin"
              :hidedOptionsFilter="hidedOptionsFilter"
              @toggleItem="toggleItemFilter"
              @selectAllElements="selectAllElements"
              @getWidthBlockSelectedElem="getWidthBlockSelectedElem"
              @getProjects="updateProjectList"
              @getTagsProject="updateTagsList"
              @getNamespacesProject="updateNamespacesList"
              @getTypesNamespace="updateTypesNamespaceList"
              @getDifficultys="updateDifficultysList"
              @getQueues="updateQueuesList"
              @getStatuses="updateStatusesList"
              @getPriorities="updatePrioritiesList"
              @setPreviousFilterValues="setPreviousFilterValues"
              @cancelChangesFilter="cancelChangesFilter"
              @resetFilter="resetFilter"
            />
          </template>
        </TirPmPopover>
        <TirPmButton
          v-if="!isSortingAndGroupingHidden && !isHideSorting"
          class="tasks-kanban-filter__button-settings"
          :variant="TirPmButtonVariantEnum.LinkState"
          :size="TirPmButtonSizeEnum.Small"
        >
          Сортировка
          <template #leftSlot>
            <ChevronDoubleUpIcon />
          </template>
        </TirPmButton>
      </div>
      <div class="tasks-kanban-filter__section-three">
        <TirPmTooltipElement :is-disabled="!noAccessTooltip">
          <TirPmSearchInput
            label="Поиск по задачам"
            class="tasks-kanban-search-input__input"
            v-model="searchTaskName"
            @update:model-value="updateSearchValue"
            placeholder=""
            isSmall
            :isWithPopup="false"
            :is-disabled="isDisabledSearch"
          />
          <template #content>
            {{ noAccessTooltip }}
          </template>
        </TirPmTooltipElement>
      </div>
    </div>
    <TaskDrawer ref="$taskDrawer" />
  </div>
</template>

<script lang="ts" setup>
import { computed, nextTick, onMounted, PropType, Ref, ref, watch } from 'vue';
import {
  TasksKanbanFilterGrouppingDropdown,
  TaskKanbanCardViewSettingsDropdown,
  TasksKanbanSearchInput,
} from './index';
import { TaskFilterStatusEnum, TasksKanbanGrouppingTypeEnum, TaskViewElementEnum } from '../enums';
import {
  PopoverPositionEnum,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmPopover,
  TirPmTooltipElement,
} from 'tir-components';
import { ChevronDoubleUpIcon } from 'tir-style-system/icons/solid';
import {
  FilterOptions,
  NamespaceModel,
  PageRequestModel,
  SelectedFilterOptions,
  TaskModel,
  TasksKanbanColumnModel,
  TasksKanbanFilterModel,
  TaskTagModel,
} from '../models';
import { debounce } from '../utils';
import { FunnelIcon } from 'tir-style-system/icons/outline';
import {
  TaskDrawer,
  TaskDrawerFormDataModel,
  TaskDrawerSettingsModel,
} from '@/components/task-forms/components/task-drawer';
import { TaskFilterModel } from '../models/TaskFilterModel';
import { TaskKanbanAdapterService } from '../adapter';
import {
  GetDifficultyListItemDetail,
  ProjectQueueTaskListItem,
  QueueTaskNamespaceModel,
} from '../adapter/TaskKanbanAdapterService';
import OptionsFilter from './options-filter/OptionsFilter.vue';
import { OptionItemModel } from './options-filter/models';
import { OptionFilterEnum } from './options-filter/enums';
import ProjectSearchRequest from '@/api/Main/dataSource/api/projects/base/i-service/models/ProjectSearchRequest';
import EnumProjectType from '@/components/sidebar/enums/EnumProjectType';
import { ProjectModel } from '@/models';
import { TagModel } from '@/components/task-forms/models';
import { TypeModel } from '@/pages/namespace-types-settings-page/models';
import { useRoute, useRouter } from 'vue-router';
import ProjectSearchRequestModel from '@/components/sidebar/models/ProjectSearchRequestModel';
import { BaseProjectResponse } from './options-filter/components/filter-parameter/adapter/models';
import TirPmSearchInput from 'tir-pm-search-input/src/TirPmSearchInput.vue';

const adapter = new TaskKanbanAdapterService();
const searchTaskName = ref<string>('');
const props = defineProps({
  /**Информация проекта */
  project: {
    type: Object as PropType<ProjectModel>,
  },
  /**Состояния получения элементов фильтра */
  stateReceivingFilter: { type: Boolean, default: true },
  /**Группировка */
  grouppingType: {
    type: Number as PropType<TasksKanbanGrouppingTypeEnum>,
    // required: true,
  },
  /**Сброси поиска */
  resetSearchState: {
    type: Boolean,
  },
  /**Отображаемые элементы */
  viewElements: {
    type: Array as PropType<Array<TaskViewElementEnum>>,
    required: true,
  },
  /**Скрытые элементы */
  hiddenViewElements: {
    type: Array as PropType<Array<TaskViewElementEnum>>,
    default: [],
  },
  /**заблокировать элементы' */
  isDisabled: {
    type: Boolean,
    required: false,
    default: true,
  },
  /**показать только где я админ для проектов точно, для областей, для очередей ...' */
  showOnlyCurrentIsAdmin: {
    type: Boolean,
    required: false,
    default: true,
  },
  /**Фильтр */
  filter: {
    type: Object as PropType<TasksKanbanFilterModel>,
    // required: true,
  },
  /**Данные задачи */
  tasks: { type: Array as PropType<TaskModel[]> },
  /**Информация неймспейса */
  namespaceInfo: { type: Object as PropType<QueueTaskNamespaceModel[]> },
  /**Информация о проектах */
  projectsInfo: { type: Array as PropType<QueueTaskNamespaceModel[]> },
  /**ID текущего проекта */
  projectId: { type: Number as PropType<number> },
  /**Скрытие сортировки и группировки */
  isSortingAndGroupingHidden: { type: Boolean as PropType<boolean>, default: false },
  /**Скрытие сортировки */
  isHideSorting: { type: Boolean, default: false },
  /**Скрытие фильтра */
  isFilterHidden: { type: Boolean as PropType<boolean>, default: false },
  /**Разрешено отсутствие группировки */
  allowNoneGroupping: { type: Boolean },
  /**Скрыть статус для настройки таблицы */
  hideStatus: { type: Boolean, default: false },
  /**Заблокировать фильтр */
  isDisabledFilter: { type: Boolean, default: false },
  /**Заблокировать поле поиска */
  isDisabledSearch: { type: Boolean, default: false },
  /**Тултип при отсутсвии доступа к элементу */
  noAccessTooltip: { type: String },
  /**опции фильтра которые не показывать */
  hidedOptionsFilter: {
    type: Array as PropType<OptionFilterEnum[]>,
    default: () => [],
  },

  namespaceId: {
    type: String,
  },
  queueId: {
    type: String,
  },
});

const emit = defineEmits<{
  /**Применить фильтр */
  (e: 'applyFilter', value: SelectedFilterOptions, filter: FilterOptions): void;
  /**Показать элементы без приоритетов */
  (e: 'stateCheckNoPriority');
  /**Событие обновления выбранной группировки */
  (e: 'update:grouppingType', value: TasksKanbanGrouppingTypeEnum): void;
  /**Событие обновления видимых элементов */
  (e: 'update:viewElements', value: Array<TaskViewElementEnum>, state: boolean): void;
  /**Событие обновления фильтра */
  (e: 'update:filter', value: TasksKanbanFilterModel): void;
  /**Применить фильтрацию */
  (e: 'filterOptions', value: TaskFilterModel);
  (e: 'cancelFilter');
  /**Событие поиска */
  (e: 'onSearch'): void;
}>();
const isChangeGlobalStatus = ref(false);
/**поменялся фильтр */
const isChange = ref(false);

const indexedViewElements: Record<number, TaskViewElementEnum> = {
  [TasksKanbanGrouppingTypeEnum.Status]: TaskViewElementEnum.Status,
  [TasksKanbanGrouppingTypeEnum.Author]: TaskViewElementEnum.Author,
  [TasksKanbanGrouppingTypeEnum.Performer]: TaskViewElementEnum.Performers,
  [TasksKanbanGrouppingTypeEnum.Priority]: TaskViewElementEnum.Priority,
  [TasksKanbanGrouppingTypeEnum.Tag]: TaskViewElementEnum.Tags,
  [TasksKanbanGrouppingTypeEnum.Type]: TaskViewElementEnum.Type,
};
let lastOnSearchValue: string;
/**Порядок отображения статусов */
const statusOrder = [
  TaskFilterStatusEnum.Starting,
  TaskFilterStatusEnum.Pause,
  TaskFilterStatusEnum.Work,
  TaskFilterStatusEnum.Success,
  TaskFilterStatusEnum.Cancelled,
  TaskFilterStatusEnum.NoStatus,
];
/**Поле поиска */
const searchField = ref<string>(null);
/**Фильтр */
const filterOptions = ref<FilterOptions>({
  GlobalStatuses: [],
  Projects: [],
  Tags: [],
  Namespaces: [],
  Types: [],
  Difficultys: [],
  Queues: [],
  Statuses: [],
  Priorities: [],
});
/**Предыдущи список фильтра */
const previousFilterValues = ref<FilterOptions>(null);
/**Выбранные элементы фильтра */
const selectedOptionsFilter = ref<SelectedFilterOptions>(
  new SelectedFilterOptions({
    Tags: [...filterOptions.value.Tags],
    Namespaces: [],
    Queues: [],
  }),
);
const list = ref<FilterOptions>();
/**Дефолтные значения элементов */
const defaultSelectedFilter = ref<SelectedFilterOptions>(null);
/**Предыдущие значения выбраных пунктов фильтра */
const previousSelectedFilterValues = ref(new SelectedFilterOptions());
/**Ссылка на компонент шторки задачи */
const $taskDrawer = ref<InstanceType<typeof TaskDrawer>>();
/**Ссылка на компонент popover */
const $popover = ref<InstanceType<typeof TirPmPopover>>();
/**Ширина блока выбранных элементов фильтра */
const widthBlockSelectedElem = ref<number>();
/**Выставлены ли теги по дефолту */
const isDefaultTagsSelected = ref(false);
/**Выставлены ли типы по дефолту */
const isDefaultTypesSelected = ref(false);
/**Выставлены ли сложности по дефолту */
const isDefaultDifficultysSelected = ref(false);
/**Выставлены ли cтатусы по дефолту */
const isDefaultStatusesSelected = ref(false);
/**Выставлены ли приоритеты по дефолту */
const isDefaultPrioritiesSelected = ref(false);
/**Не активна кнопка Отмена фильтра */
const isDisabledCancelFilter = ref(true);
/**Был ли применен фильтр */
const isApplyFilter = ref(false);
/**Используется для одной иникиализации старого списка тегов */
const isTagsInitOnce = ref(true);
/**Используется для одной иникиализации старого списка НС */
const isNamespacesInitOnce = ref(true);
/**Используется для одной иникиализации старого списка типов */
const isTypesInitOnce = ref(true);
/**Используется для одной иникиализации старого списка сложностей */
const isDifficultyInitOnce = ref(true);
/**Используется для одной иникиализации старого списка очередей */
const isQueueInitOnce = ref(true);
/**Используется для одной иникиализации старого списка статусов */
const isStatusesInitOnce = ref(true);
/**Используется для одной иникиализации старого списка приоритетов */
const isPriorityInitOnce = ref(true);
const changeIndicatorState = ref(false);
const isOpenOptionsFilterGroupping = ref();
const isOpenOptionsViewSettings = ref();
const disabledViewElementsCheckboxes = computed(() => [indexedViewElements[props.grouppingType]]);
import { useTaskKanbanFilter } from '../../../pages/tasks-order-pages/adapter-service/useTaskKanbanFilter';
import { mapGetProjectRequest } from '@/layouts/project-tasks-layout/adapter/AdapterServiceMappers';
const oldListFilter = ref(new FilterOptions());
const { loadZmkTaskByPerformerListRequestLocalstore, zmkTaskByPerformerListRequest } =
  useTaskKanbanFilter();
watch(
  () => $popover.value?.visible,
  () => {
    if (!$popover.value?.visible) {
      filterOptions.value = JSON.parse(JSON.stringify(oldListFilter.value));
    }
  },
);

/**После рендера компонента */
onMounted(async () => {
  isChangeGlobalStatus.value = false;
  isChange.value = false;
  await getGlobalStatuses();
  initSelectedOptionsFilter();
  oldListFilter.value.GlobalStatuses = filterOptions.value.GlobalStatuses;
  await getProjects();
  // selectedOptionsFilter.value.Projects =
  //   filterOptions.value.Projects.length > 1
  //     ? [new OptionItemModel({ Id: 0 })]
  //     : [filterOptions.value.Projects[0]];
  defaultSelectedFilter.value = new SelectedFilterOptions(selectedOptionsFilter.value);

  // loadZmkTaskByPerformerListRequestLocalstore();
});

/**Получить ширину блока выбранных элементов фильтра */
const getWidthBlockSelectedElem = (count: number) => {
  widthBlockSelectedElem.value = count;
};
/** Добавление/удаление элемента в фильтре */
const toggleItemFilter = (
  item: OptionItemModel,
  type: OptionFilterEnum,
  isMultiSelect: boolean,
): void => {
  if (type == OptionFilterEnum.GlobalStatuses) {
    isChangeGlobalStatus.value = true;
  }

  const currentList = selectedOptionsFilter.value[type] as OptionItemModel[];

  if (type == OptionFilterEnum.Projects && item?.Id) {
    isChange.value = true;
  }

  if (isMultiSelect) {
    const exists = currentList.some((i) => i.Id === item.Id);

    (selectedOptionsFilter.value[type] as OptionItemModel[]) = exists
      ? currentList.filter((i) => i.Id !== item.Id)
      : [...currentList, item];
  } else {
    (selectedOptionsFilter.value[type] as OptionItemModel[]) = [item];
  }
  switch (type) {
    case OptionFilterEnum.Projects:
      isDefaultTagsSelected.value = false;
      selectedOptionsFilter.value.Tags = [];
      // oldListFilter.value.Projects = [
      //   ...selectedOptionsFilter.value.Projects,
      //   ...oldListFilter.value.Projects,
      // ];
      selectedOptionsFilter.value.Namespaces = [];
      selectedOptionsFilter.value.Queues = [];
      filterOptions.value.Difficultys = [];
      selectedOptionsFilter.value.Difficultys = [];
      selectedOptionsFilter.value.Priorities = [];
      break;
    case OptionFilterEnum.Namespaces:
      isDefaultTypesSelected.value = false;
      isDefaultDifficultysSelected.value = false;
      selectedOptionsFilter.value.Types = [];
      selectedOptionsFilter.value.Difficultys = [];
      filterOptions.value.Difficultys = [];
      // oldListFilter.value.Namespaces = [
      //   ...selectedOptionsFilter.value.Namespaces,
      //   ...oldListFilter.value.Namespaces,
      // ];

      break;
    case OptionFilterEnum.Queues:
      isDefaultStatusesSelected.value = false;
      selectedOptionsFilter.value.Statuses = [];
      isDefaultPrioritiesSelected.value = false;
      selectedOptionsFilter.value.Priorities = [];
      // oldListFilter.value.Queues = [
      //   ...selectedOptionsFilter.value.Queues,
      //   ...oldListFilter.value.Queues,
      // ];
      break;
  }
};
const route = useRoute();

/**предустановленный фильтр */
async function initSelectedOptionsFilter() {
  const x = props.hidedOptionsFilter;
  const isProjectDisable = !!x.find((el) => el == OptionFilterEnum.Projects);
  const isNamespaceDisable = !!x.find((el) => el == OptionFilterEnum.Namespaces);
  if (isProjectDisable) {
    const project = await adapter.getProjectById(props.projectId);
    if (project.IsSuccess) {
      const projectData = new OptionItemModel({
        Id: project.Value.Id,
        Color: project.Value.PreviewColor,
        Name: project.Value.Name,
        Image: project.Value.ImageUrl,
        GlobalStatusType: project.Value.Status,
      });
      selectedOptionsFilter.value.Projects = [projectData];
      toggleItemFilter(projectData, OptionFilterEnum.Projects, false);

      const namespace = await adapter.getNamespaceById(props.namespaceId);
      if (namespace.IsSuccess) {
        const namespaceData = new OptionItemModel({
          Id: namespace.Value.NamespaceId,
          Name: namespace.Value.Name,
          Color: namespace.Value.Color,
          Image: namespace.Value.IconUrl,
        });
        selectedOptionsFilter.value.Namespaces = [namespaceData];
        toggleItemFilter(namespaceData, OptionFilterEnum.Namespaces, false);

        const queue = await adapter.getQueueById(props.queueId);
        if (queue.IsSuccess) {
          const queueData = new OptionItemModel({
            Id: queue.Value.Id,
            Name: queue.Value.Name,
          });
          selectedOptionsFilter.value.Queues = [queueData];
          toggleItemFilter(queueData, OptionFilterEnum.Queues, false);
        }
      }
    }
  }
  if (isNamespaceDisable) {
    selectedOptionsFilter.value.Namespaces = [new OptionItemModel({ Id: props.namespaceId })];
  }
}

/**Выбрать все элементы в фильтре */
const selectAllElements = (type: OptionFilterEnum, isMultiSelect: boolean) => {
  const isSelectAllElements =
    filterOptions.value[type].length !== selectedOptionsFilter.value[type].length;

  if (isMultiSelect) {
    (selectedOptionsFilter.value[type] as OptionItemModel[]) = isSelectAllElements
      ? [...(filterOptions.value[type] as OptionItemModel[])]
      : [];
  } else {
    selectedOptionsFilter.value[type] = [];
    if (type == OptionFilterEnum.Projects) {
      selectedOptionsFilter.value.Namespaces = [];
      selectedOptionsFilter.value.Queues = [];
      isApplyFilter.value = false;
    }
  }
};
const emitOnSearch = () => {
  if (lastOnSearchValue === props.filter.Search) return;
  lastOnSearchValue = props.filter.Search;

  emit('onSearch');
};
const debounceEmitOnSearch = debounce(emitOnSearch, 300);
const checkOpenOptionsFilterGroupping = (value) => {
  isOpenOptionsFilterGroupping.value = value;
};
const checkOpenOptionsViewSettings = (value) => {
  isOpenOptionsViewSettings.value = value;
};
let timer;
const updateSearchValue = (value: string) => {
  if (timer) {
    clearTimeout(timer);
  }
  timer = setTimeout(() => {
    props.filter.Search = searchTaskName.value;
    emit('update:filter', { ...props.filter });
    debounceEmitOnSearch();
  }, 300);
};
const checkViewElement = (elementType: TaskViewElementEnum[], state: boolean) => {
  emit('update:viewElements', elementType, state);
};
const updateGrouppingType = (grouppingType: TasksKanbanGrouppingTypeEnum) => {
  emit('update:grouppingType', grouppingType);
};
/**
 * * Открыть создание задачи
 * @param column Колонка
 */
const openCreateTask = (column?: TasksKanbanColumnModel) => {
  const groupping = column?.Grouping;
  $taskDrawer.value?.open(
    new TaskDrawerSettingsModel({
      Mode: 'create',
      ProjectId: props.projectId,
      QueueId: null,
      NamespaceId: null,
      FormData: new TaskDrawerFormDataModel({
        StatusId: groupping?.Status?.Id,
        PriorityId: groupping?.Priority?.Id,
        TypeId: groupping?.Type?.Id,
        PerformerIds: groupping?.Performer?.Id ? [groupping.Performer.Id] : [],
        Tags: groupping?.Tag?.Id ? [groupping.Tag.Id] : [],
        Types: groupping?.Type?.Id ? [groupping.Type.Id] : [],
      }),
    }),
  );
};
/**Получить глобальные статусы */
const getGlobalStatuses = async () => {
  const response = await adapter.getGlobalStatuses();
  if (response.IsSuccess) {
    response.Value.Items.sort((a, b) => {
      const indexA = statusOrder.indexOf(a.Name as TaskFilterStatusEnum);
      const indexB = statusOrder.indexOf(b.Name as TaskFilterStatusEnum);

      return indexA - indexB;
    });

    filterOptions.value.GlobalStatuses = response.Value.Items;
    selectedOptionsFilter.value.GlobalStatuses = response.Value.Items.filter(
      (elem) => elem.Name !== TaskFilterStatusEnum.Success,
    );
  }
};
/** Обновить список проектов */
const updateProjectList = async (data: OptionItemModel[]) => {
  filterOptions.value.Projects = data;
};
/** Получить список проектов */
const getProjects = async (searchText?: string) => {
  const response = await adapter.GetProjects(
    new ProjectSearchRequestModel({
      Name: searchText,
      Status: [EnumProjectType.Active],
      ShowOnlyCurrentIsAdmin: props.showOnlyCurrentIsAdmin,
      Page: new PageRequestModel({
        Skip: 0,
        Take: 20,
      }),
    }),
  );

  if (!response.IsSuccess) return;
  /**ID выбраных элементов проекта */
  const existingIds = new Set(selectedOptionsFilter.value.Projects.map((p) => p?.Id));
  /**Выбранные элементы */
  const selectedElements = selectedOptionsFilter.value.Projects.filter((p) => p?.Id !== 0).map(
    (p) => new ProjectModel({ ...p, PreviewColor: p?.Color, ImageUrl: p?.Image }),
  );

  let filteredProjects: OptionItemModel[] = [];

  filteredProjects = response.Value.Projects.filter((p) => !existingIds.has(p?.Id)).map(
    (project: BaseProjectResponse) =>
      new OptionItemModel({
        Id: project?.Id,
        Color: project?.PreviewColor,
        Name: project?.Name,
        Image: project?.ImageUrl,
      }),
  );
  filterOptions.value.Projects = [...selectedElements, ...filteredProjects];
  oldListFilter.value.Projects = [...filteredProjects];
};
/**Обновить список тегов */
const updateTagsList = (tags: TagModel[]) => {
  const existingIds = new Set(selectedOptionsFilter.value.Tags.map((t) => t.Id));
  const uniqueTags = tags.filter((tag) => !existingIds.has(tag.Id));

  filterOptions.value.Tags = [...(selectedOptionsFilter.value.Tags as TagModel[]), ...uniqueTags];

  if (!isDefaultTagsSelected.value) {
    selectedOptionsFilter.value.Tags = [...uniqueTags];
    isDefaultTagsSelected.value = true;
  }
  if (isTagsInitOnce.value) {
    oldListFilter.value.Tags = [...tags];
    isTagsInitOnce.value = false;
  }

  defaultSelectedFilter.value.Tags = tags;
};
/**Обновить список НС проекта */
const updateNamespacesList = (namespaces: OptionItemModel[]) => {
  const selected = selectedOptionsFilter.value.Namespaces;
  const selectedIds = new Set(selected.map((namespace) => namespace.Id));

  const unique = namespaces.filter((namespace) => !selectedIds.has(namespace.Id));

  const selectedAsNamespaceItems = selected.filter((namespace) => namespace.Id !== 0);

  filterOptions.value.Namespaces = [...selectedAsNamespaceItems, ...unique];

  if (isNamespacesInitOnce.value) {
    oldListFilter.value.Namespaces = [...namespaces];
    isNamespacesInitOnce.value = false;
  }
};
/**Обновить список типов */
const updateTypesNamespaceList = (types: TypeModel[]) => {
  const existingIds = new Set(selectedOptionsFilter.value.Types.map((t) => t.Id));
  const uniqueTypes = types.filter((type) => !existingIds.has(type.Id));

  filterOptions.value.Types = [
    ...(selectedOptionsFilter.value.Types as TypeModel[]),
    ...uniqueTypes,
  ];
  if (!isDefaultTypesSelected.value) {
    selectedOptionsFilter.value.Types = [...uniqueTypes];
    isDefaultTypesSelected.value = true;
  }
  if (isTypesInitOnce.value) {
    oldListFilter.value.Types = [...types];
    isTypesInitOnce.value = false;
  }
};
/**Обновить список сложностей */
const updateDifficultysList = (difficultys: OptionItemModel[]) => {
  const existingIds = new Set(selectedOptionsFilter.value.Difficultys.map((d) => d.Id));

  const unique = difficultys.filter((d) => !existingIds.has(d.Id));

  filterOptions.value.Difficultys = [...selectedOptionsFilter.value.Difficultys, ...unique];
  if (!isDefaultDifficultysSelected.value) {
    selectedOptionsFilter.value.Difficultys = [...difficultys];
    isDefaultDifficultysSelected.value = true;
  }

  if (isDifficultyInitOnce.value) {
    oldListFilter.value.Difficultys = [...difficultys];
    isDifficultyInitOnce.value = false;
  }
};
/**Обновить список очередей */
const updateQueuesList = (newQueues: ProjectQueueTaskListItem[]) => {
  const selected = selectedOptionsFilter.value.Queues;
  const selectedIds = new Set(selected.map((queue) => queue.Id));

  const uniqueNewQueues = newQueues.filter((queue) => !selectedIds.has(queue.Id));

  const selectedAsQueueItems = selected
    .map(
      (queue) =>
        new ProjectQueueTaskListItem({
          Id: String(queue.Id),
          Name: queue.Name,
        }),
    )
    .filter((queue) => queue.Id !== '0');

  filterOptions.value.Queues = [...selectedAsQueueItems, ...uniqueNewQueues];
  if (isQueueInitOnce.value) {
    oldListFilter.value.Queues = [...newQueues];
    isQueueInitOnce.value = false;
  }
};
const isAllElementsStatus = ref(false);
/**Обновить список статустов */
const updateStatusesList = (statuses: OptionItemModel[], isGlobalStatusChanged: boolean) => {
  const existingIds = new Set(selectedOptionsFilter.value.Statuses.map((d) => d.Id));

  const unique = statuses.filter((d) => !existingIds.has(d.Id));
  filterOptions.value.Statuses = [...selectedOptionsFilter.value.Statuses, ...unique];

  if (!isDefaultStatusesSelected.value) {
    selectedOptionsFilter.value.Statuses = [...statuses];
    isAllElementsStatus.value = true;
    isDefaultStatusesSelected.value = true;
  }

  if (isGlobalStatusChanged && isAllElementsStatus.value) {
    selectedOptionsFilter.value.Statuses = [...statuses];
  } else {
    if (isGlobalStatusChanged) {
      filterOptions.value.Statuses = [...statuses];
      selectedOptionsFilter.value.Statuses = selectedOptionsFilter.value.Statuses.filter((s) =>
        statuses.some((st) => st.Id === s.Id),
      );
    }
  }

  if (isStatusesInitOnce.value) {
    oldListFilter.value.Statuses = [...statuses];
    isStatusesInitOnce.value = false;
  }
};
/**Обновить список приоритетов */
const updatePrioritiesList = (priorities: OptionItemModel[]) => {
  const existingIds = new Set(selectedOptionsFilter.value.Priorities.map((p) => p.Id));

  const unique = priorities.filter((p) => !existingIds.has(p.Id));

  filterOptions.value.Priorities = [...selectedOptionsFilter.value.Priorities, ...unique];
  if (!isDefaultPrioritiesSelected.value) {
    selectedOptionsFilter.value.Priorities = [...priorities];
    isDefaultPrioritiesSelected.value = true;
  }
  if (isPriorityInitOnce.value) {
    oldListFilter.value.Priorities = [...priorities];
    isPriorityInitOnce.value = false;
  }
};
/**Заполнение предыдущими значениями пункты фильтра */
const setPreviousFilterValues = (
  previousSelectedFilter: SelectedFilterOptions,
  previousFilter: FilterOptions,
) => {
  previousSelectedFilterValues.value = new SelectedFilterOptions(previousSelectedFilter);
  previousFilterValues.value = new FilterOptions(previousFilter);
  isDisabledCancelFilter.value = false;

  $popover.value?.close();
  const x = {
    GlobalStatusIds: [0, 3, 2, 4, 5],
  };
  if (
    selectedOptionsFilter.value.Difficultys.length == 0 &&
    selectedOptionsFilter.value.GlobalStatuses.length == 5 &&
    JSON.stringify(
      [...selectedOptionsFilter.value.GlobalStatuses.map((el) => el.GlobalStatusType)].sort(),
    ) === JSON.stringify([...x.GlobalStatusIds].sort()) &&
    selectedOptionsFilter.value.Difficultys.length == 0 &&
    selectedOptionsFilter.value.HiddenElements.length == 0 &&
    selectedOptionsFilter.value.Queues?.length == 0 &&
    selectedOptionsFilter.value.Namespaces?.length == 0 &&
    selectedOptionsFilter.value.Projects?.length == 0 &&
    selectedOptionsFilter.value.Tags.length == 0 &&
    selectedOptionsFilter.value.Types.length == 0 &&
    selectedOptionsFilter.value.Statuses.length == 0 &&
    selectedOptionsFilter.value.Priorities.length == 0
  ) {
    isApplyFilter.value = false;
  } else {
    isApplyFilter.value = true;
  }
  emit('applyFilter', selectedOptionsFilter.value, filterOptions.value);
};
/**Отменить изменения в фильтре */
const cancelChangesFilter = () => {
  filterOptions.value = JSON.parse(JSON.stringify(previousFilterValues.value));
  selectedOptionsFilter.value = JSON.parse(JSON.stringify(previousSelectedFilterValues.value));
  const x = {
    GlobalStatusIds: [0, 3, 2, 4, 5],
  };
  if (
    selectedOptionsFilter.value.Difficultys.length == 0 &&
    selectedOptionsFilter.value.GlobalStatuses.length == 5 &&
    JSON.stringify(
      [...selectedOptionsFilter.value.GlobalStatuses.map((el) => el.GlobalStatusType)].sort(),
    ) === JSON.stringify([...x.GlobalStatusIds].sort()) &&
    selectedOptionsFilter.value.Difficultys.length == 0 &&
    selectedOptionsFilter.value.HiddenElements.length == 0 &&
    selectedOptionsFilter.value.Queues?.length == 0 &&
    selectedOptionsFilter.value.Namespaces?.length == 0 &&
    selectedOptionsFilter.value.Projects.length == 0 &&
    selectedOptionsFilter.value.Tags.length == 0 &&
    selectedOptionsFilter.value.Types.length == 0 &&
    selectedOptionsFilter.value.Statuses.length == 0 &&
    selectedOptionsFilter.value.Priorities.length == 0
  ) {
    isApplyFilter.value = false;
  } else {
    isApplyFilter.value = true;
  }
  $popover.value?.close();
};
/**Сбросить фильтр */
const resetFilter = () => {
  isApplyFilter.value = false;
  defaultSelectedFilter.value.Tags = [];
  defaultSelectedFilter.value.Projects = [];
  selectedOptionsFilter.value = JSON.parse(JSON.stringify(defaultSelectedFilter.value));
};

defineExpose({ selectedOptionsFilter, filterOptions });
</script>

<style lang="scss" scoped>
.selected-namespace-block {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-right: 0.75rem;
  font-size: 0.75rem;
  color: var(--text-secondary, #686c73);

  .icon {
    width: 1rem;
    height: 1rem;
  }
}

.button-filter {
  position: relative;
}

.oprions-filter:hover {
  background: var(--neutral-translucent-5, rgba(39, 45, 55, 0.05));
}

.change-indicator {
  position: absolute;
  right: -0.1875rem;
  top: -0.25rem;
  border-radius: 1rem;
  background-color: red;
  width: 0.625rem;
  height: 0.625rem;
}

.icon {
  width: 1.5rem;
  height: 1.5rem;
}

:deep(.input-container__input-label) {
  &:empty {
    display: none;
  }
}
:deep(.input-container__input-wrapper) {
  height: 2.25rem;
}

:deep(.input-container__input) {
  margin-bottom: 0;
  line-height: 2.25rem;
}

.dimondIcon {
  color: var(--neutral-70, #686c73);
}

.chevron-button {
  min-width: 1.5rem;
}

.tasks-kanban__header__add-button {
  position: sticky;
  right: 0;
}

.tasks-kanban-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 2.25rem;
  margin-bottom: 1rem;

  &__elements {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
  }

  &__queue-item {
    display: flex;
    align-items: center;
    font-size: 0.75rem;
    color: var(--text-secondary, #686c73);
  }

  &__item {
    display: flex;
    align-items: center;
  }

  &__item-block {
    display: flex;
    gap: 0.75rem;
  }

  &__hidden-admin-item {
    padding: 0.75rem;
  }

  &__view-item {
    display: flex;
  }

  &__button-settings {
    border-radius: var(--8);
    &:hover {
      background-color: var(--neutral-translucent-5);
    }
  }

  &__button-group {
    display: flex;
    gap: 0.75rem;
  }

  &__button-block {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 1.5rem;
  }

  &__filter-item-content {
    display: flex;
    align-items: center;
  }
  &__block-content {
    padding: 0.75rem;
  }
  &__first-section {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.75rem;
  }
  &__second-section {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
  &__filter-item-block {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__filter-item-title {
    margin-right: 0.75rem;
    margin-left: 0.75rem;
  }
}
</style>

<style lang="scss">
.time-estimate-input-block {
  .input-container__input-wrapper {
    height: 3.25rem !important;
  }
}

.disabledState {
  .button__sign {
    color: var(--text-tertiary, #93969b);
  }
}
</style>
